import Api from 'api/api';

class ShopApi {
    postPayment(body) {
        return Api.post('/public/kiosk/temp-kiosk-data', body);
    }
}

export default new ShopApi();
